var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("gmap-autocomplete", {
        ref: "autocomplete",
        staticClass: "form-control",
        attrs: {
          value: _vm.newPlace,
          type: "text",
          placeholder: _vm.$t("Address"),
          "select-first-on-enter": true,
          disabled: _vm.disabled,
        },
        on: {
          place_changed: _vm.updateAddress,
          input: function ($event) {
            _vm.newPlace = $event.target.value
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }